/** 素材 detail 資料，只列出共通欄位，其他非共通欄位用 string-literal */
export class Detail {
  /** 代表圖像(列表加速用+需要額外處理) */
  repImage: string;
  /** 給 detail用的圖片 */
  images?: {
    url: string;
    description: string;
    width: number;
    height: number;
  }[];
  /** 來源資料授權方式--圖像 */
  imageLic: string;
  /** 下載圖片的連結 */
  downloadImages?: string[];
  /** 影音連結 */
  iframeUrl?: string;
  /** 標題/名稱 */
  title: string;
  /** 描述 (可能是HTML) */
  description: string;
  /** 來源資料授權方式--描述 */
  contentLic: string;
  /** 原始資料連結 */
  linkPath: string;
  /** 資料來源機關 */
  sourceName: string;
  /** 來源系統識別號 */
  uid: string;
  /** 主題分類 */
  subjects: string[];
  /** 關鍵字 */
  keywords: string[];
  /** 更多資料 */
  relevant: {
    materialId: string;
    fetchIndex: string;
    description: string;
    materialName: string;
    image: string;
  }[];
  /** 建檔單位 */
  createDept: string;
  /** 檢視次數 */
  viewCount: number;
}

export const COMMON_FIELD_KEYS = ['repImage', 'images', 'imageLic', 'downloadImages', 'iframeUrl',
'title', 'description', 'contentLic', 'linkPath', 'sourceName', 'uid', 'subjects', 'keywords', 'createDept', 'viewCount'];
